{
  "version": 1,
  "asset_id": "2c254c8d-7f22-4ca9-92af-c27770a07f84",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/2c254c8d-7f22-4ca9-92af-c27770a07f84/cleaning-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/2c254c8d-7f22-4ca9-92af-c27770a07f84/cleaning-card.webp",
  "original_filename": "cleaning-card.webp",
  "size": 15982,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:56Z"
}
